import {Criteria} from './Criteria';

export interface Query {
  type: QueryType;
  value: Criteria[];
  operator: QueryOperator;
}

export enum QueryType {
  ContentAndMetadata = 'ContentAndMetadata',
  Conceptual = 'Conceptual',
  WorkProduct = 'WorkProduct',
  Analytics = 'Analytics',
}

export type QueryOperator = 'AND' | 'OR' | 'NOT';
